import { render, staticRenderFns } from "./carouselBanner.vue?vue&type=template&id=136d3f51&scoped=true&"
import script from "./carouselBanner.vue?vue&type=script&lang=js&"
export * from "./carouselBanner.vue?vue&type=script&lang=js&"
import style0 from "./carouselBanner.vue?vue&type=style&index=0&id=136d3f51&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d3f51",
  null
  
)

export default component.exports